import axios from 'axios';
import { NEWS_API_URL } from 'lib/api';

import { getHeaders } from './headers';

export const getPostsByCategory = async (category) => {
  try {
    const res = await axios.get(`${NEWS_API_URL}/post/getPost/` + { category }, getHeaders());
    if (res.data.name === 'AxiosError') return null;

    return res.data;
  } catch (e) {
    return e;
  }
};

export const getAllCategory = async () => {
  try {
    const res = await axios.get(`${NEWS_API_URL}/category/getAll`, getHeaders());
    if (res.data.name === 'AxiosError') return null;

    return res.data;
  } catch (e) {
    return e;
  }
};
